import { createAppHttpClient } from '@hwm/ui-lib/core/http';
import { store } from '@core/store/store';
import { environment } from '@root/environment';
import axios from 'axios';

export const httpClient = createAppHttpClient(
  (() => store.getState()) as any,
  {
    sessionCookieDomain: environment.sessionCookieDomain,
    sessionCookieIsSecure: environment.sessionCookieSecure,
    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
  },
  {
    baseURL: environment.apiUrl,
  }
);

export default httpClient;

export const minioClient = createAppHttpClient(
  (() => store.getState()) as any,
  {
    sessionCookieDomain: environment.sessionCookieDomain,
    sessionCookieIsSecure: environment.sessionCookieSecure,
    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
  },
  {
    baseURL: environment.apiUrl,
    noAppId: true,
  }
);

const basicClient = axios.create({
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
  baseURL: environment.apiUrl,
});

export const simpleClient = basicClient;
